module.exports = __webpack_public_path__ + "static/favicon-152-touch-47825ccca0abcac5b0629b668944af56.png";